/**
 * @copyright Copyright © 2020-2025 Airbus DS SLC. All rights reserved.
 *
 * @module Application
 * @description Represents an application module.
 * @exports Application
 */

import {Bootstrap} from "@airbus/library-bootstrap";
import log from "loglevel";

/**
 * Represents an application.
 * @class
 */
export class Application {
    /**
     * The name of the application.
     * @name Application#name
     * @type {string}
     * @readonly
     */
    #namespace;
    /**
     * The bootstrap instance for module initialization.
     * @type {Bootstrap}
     */
    bootstrap;
    /**
     * The global logger.
     * @type {Object}
     */
    log;

    /**
     * Creates an instance of Application.
     * @param {string} namespace - The namespace for the application.
     * @example
     * const app = new Application('myApp');
     */
    constructor(namespace) {
        this.log = log;
        this.bootstrap = new Bootstrap(this);
        this.#namespace = namespace;
        // Expose the application instance globally
        globalThis[namespace] = this;
    }

    get name() {
        return this.#namespace;
    }
}
